import React from "react";
import { ReactComponent as Remove } from "../Global Icons/CancelButton.svg";

const MultipleImagesShowerModalGlobal = ({ state, setState, fieldName }) => {
  const handleRemoveImage = async (indexToRemove) => {
    setState((prevData) => {
      const updatedImages = prevData[fieldName]
        .filter((_, index) => index !== indexToRemove)
        .map((item, index) => ({
          ...item,
          index: index + 1,
        }));

      return {
        ...prevData,
        [fieldName]: updatedImages,
      };
    });
  };

  return (
    <div className="flex-container gap-10 border-20 flex-wrap">
      {state.map((item, index) => (
        <div
          key={index}
          className="border-15 border-1-grey upload-image-shower"
        >
          <img src={item.url} alt="" />
          <div
            onClick={() => {
              handleRemoveImage(index);
            }}
          >
            <Remove />
          </div>
        </div>
      ))}
    </div>
  );
};

export default MultipleImagesShowerModalGlobal;
